import React from 'react';

function CardItem(props) {
    return (
        <>
        { (props.v === "1") ? 
        (
        <div className='feature'>
            {props.html}
            <div className=''>
                <h3 className='featurehead'>{props.head}</h3>
                <p className='featureparagraph'>{props.text}</p>
            </div> 
        </div>
        ):(
            <div className='feature-2'>
                {props.html}
                <div className='2'>
                    <h3 className='featurehead'>{props.head}</h3>
                    <p className='featureparagraph-2'>{props.text}</p>
                </div> 
            </div>
        )
        }
            
        </>
    )
}

export default CardItem;
